define('app/sdc/input/group/sdc-input-group',[], function () {
	return {
		transclude: true,
		deprecated: 'use the class "sdc-input-group" instead.',
		require: {
			"crud": "^sdcCrud"
		},
		model:{
			"controlClass": "=?controlClass"
		},
		controller: ["$attrs", function ($attrs) {
			if(! ("controlClass" in $attrs)){
				this.controlClass = "col-xs-3";
			}
		}],
		link: function (scope, iElement, iAttrs, controller, transcludeFn) {

			transcludeFn(function (clone) {
				iElement.prepend(clone);
			});
		}
	};
});
